export interface Import {
    activate?:                  boolean;
    classificationDestination?: ClassificationDestination;
    fields?:                    Field[];
    formsMapping?:              FormsMapping[];
    indexInAllAvailableLocale?: boolean;
}

export interface ClassificationDestination {
    type?: Type;
}

export enum Type {
    ClassificationValidationRequest = "CLASSIFICATION_VALIDATION_REQUEST",
    Folder = "FOLDER",
}

export interface Field {
    field:             string;
    required?:         boolean;
    thesaurusSettings: ThesaurusSettings;
}

export interface ThesaurusSettings {
    treeViewByDefault: boolean;
}

export interface FormsMapping {
    formId: number;
}
